import React, { useEffect, useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import View from '../Canvas/View';
import ToolbarPanel from '../Components/Toolbar/ToolbarPanel';
import StoreController from '../StoreController';
import EditorStateContext from './EditorStateContext';
// import Alerts from '../Components/AlertsContainer';
import { rxFetchPages } from '../rx/actions/rxFetchPages';
import {
  rxIsLoading,
  rxError,
  rxShowExitModal,
  rxUserName,
  eventEmiter,
  rxPageId,
  rxPageSaved,
} from '../rx/rxState';

import { useObservable } from '../utils/UseObservable';
import SideMenu from '../Components/SideMenu/SideMenu';
import { fetchSectionsMenu } from '../rx/actions/rxFetchSectionsMenu';
import ModalExit from '../Components/Modals/ModalExit/ModalExit';
import { isAdmin, getToken, api, username, getUserId } from '../utils/api';
import SectionEditor from '../Components/SectionEditor';
import Spinner from '../Components/Common/Spinner/Spinner';
import { useSearchParams } from 'Hooks/useSearchParams';
import OpenEditorPanel from 'Components/OpenEditorPanel/OpenEditorPanel';
import SignUpPopup from 'Components/Popups/SignUpPopup';
import SaveWebSite from 'Components/Popups/SaveWebSite';
import Login from 'Components/Popups/LogIn';
import { CONSULT_URL, API_PROJECT } from 'Constants';
import { useLocation } from 'react-router';

import s from './PageApp.module.scss';
import RecommendUseDesktopPopup from 'Components/Popups/RecommendUseDesktopPopup';

const AppStyle = styled.div`
  height: 100vh;
  min-width: 600px;
  background-color: #eaedef;
  position: relative;
  overflow: hidden;

  .main-content {
    display: grid;
    grid-template-columns: max-content auto ${(props) =>
        props.isAdmin ? 'min-content;' : ';'};
    height: calc(100vh - 60px);
  }
`;

const ToolbarStyle = styled.div`
  color: white;
  display: flex;
  height: 60px;
`;

const SidebarStyle = styled.div`
  width: max-content;
  background: black;
`;

const CanvasStyle = styled.div`
  position: relative;
  background-image: url(${process.env.PUBLIC_URL}/assets/bg.png);
`;



const PageApp = (props) => {
  const location = useLocation();
  const [editor, setEditor] = useState({});
  const [signUpModalIsOpen, setSignUpModalIsOpen] = useState(false);
  const [recommendUseDesktopModalIsOpen, setRecommendUseDesktopModalIsOpen] = useState(false);

  const [stripePlanView, setStripePlanView] = useState('withoutInput');

  const loading = useObservable(rxIsLoading);
  const hasPageSaved = useObservable(rxPageSaved);
  const hasUserLoggedIn = !!getToken();

  const error = useObservable(rxError);

  useLayoutEffect(()=>{
    const mediaQuery = window.matchMedia('(max-width: 600px)');
    if (!mediaQuery.matches) return
    setRecommendUseDesktopModalIsOpen(true)
  },[])

  const {
    query: { generated },
  } = useSearchParams();
  // console.log(generated, signup)
  const [savePopUpOpen, setSavePopUpOpen] = useState(false);
  const [loginPopUpOpen, setLoginPopUpOpen] = useState(false);
  const [timeToOpenModalHasPassed, setTimeToOpenModalHasPassed] =
    useState(false);
  const [modalHasBeenClosed, setModalHasBeenClosed] = useState(false);
  const [userId, setUserId] = useState('');
  const [productId, setProductId] = useState('');
  const { setParam } = useSearchParams();

  const setEditorState = (data) => {
    if (data === null) {
      setEditor({ state: null });
      return;
    }
    let colorStyleMap = data.colorStyleMap;
    if (colorStyleMap === undefined) {
      colorStyleMap = editor.colorStyleMap;
    }

    let sizeStyleMap = data.sizeStyleMap;
    if (sizeStyleMap === undefined) {
      sizeStyleMap = editor.sizeStyleMap;
    }

    setEditor({
      state: data.state,
      colorStyleMap,
      sizeStyleMap,
    });
  };

  const handleChangeEditor = (newEditorState) => {
    const oldEditor = { ...editor };
    setEditor({
      ...oldEditor,
      state: newEditorState,
    });
  };

  useEffect(() => {
    if (hasPageSaved) {
      rxIsLoading.next('');
      if (userId && productId) {
        const editUrl = `/edit/edit/${userId}/${productId}/optin`;
        window.open(editUrl, '_self');
      }
      rxPageSaved.next(false);
    }
  }, [hasPageSaved]);

  const saveProject = async () => {
    try {
      rxIsLoading.next(true);
      const token = getToken();
      const owner = username(token);
      const userId = getUserId();
      setUserId(userId);
      
      if(props.productId == 'new'){
        const payloadCreateGeneralProject = {
          username: owner,
          name: 'First Project',
          userId: userId,
          action: 'add',
        };
        const generalProject = await api(
          API_PROJECT,
          'POST',
          payloadCreateGeneralProject
        );

        const payloadCreateFunnel = {
          name: 'First funnel',
          enabled: true,
          id: generalProject[0]._id,
          action: 'addProduct',
        };
        
        const funnel = await api(API_PROJECT, 'POST', payloadCreateFunnel);
        setProductId(funnel._id);
        rxPageId.next(funnel._id);
      }
      else{
        setProductId(props.productId);
        rxPageId.next(props.productId);
      }

      eventEmiter.next({
        type: 'save',
        payload: {
          modalView: false,
        },
      });
    } catch (err) {
      rxIsLoading.next(false);
      console.error('Save page error', err);
    }
  };

  const handleSaveEditorPanel = async () => {
    if (hasUserLoggedIn) {
      await saveProject();
    } else {
      setSignUpModalIsOpen(true);
    }
  };

  useEffect(() => {
    if (props.productId === 'new') {
      return;
    }
    console.log('page app update');
    rxFetchPages({
      username: props.username,
      id: props.productId,
      editMode: props.editMode,
      page: props.page,
      productMode: props.productMode,
      applyBlocks: !generated,
    });
    if (props.editMode) {
      fetchSectionsMenu();
    }
  }, []);

  // useEffect(() => {
  //   setSignUpModalIsOpen(false);
  //   setTimeout(() => {
  //     setTimeToOpenModalHasPassed(true);
  //   }, 7000);
  //   const handleScroll = () => {
  //     const scrollPercent =
  //       (window.pageYOffset / document.body.scrollHeight) * 100 * 1.19;
  //     if (scrollPercent >= 90) {
  //       setSignUpModalIsOpen(true);
  //     }
  //   };

  //   window.addEventListener('scroll', handleScroll);

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // }, []);

  useEffect(() => {
    if(location.hash.search('signup') >= 0){
      setSignUpModalIsOpen(true);
      if (location.hash.search('1') >= 0) {
        setStripePlanView('withInput');
      } else {
        setStripePlanView('withoutInput');
      }
    }
    else{
      setSignUpModalIsOpen(false);
    }
  }, [location]);

  let sc = StoreController.instance();
  sc.liveMode = !props.editMode;
  sc.productionMode = props.productMode;

  const handleCloseExitModal = () => {
    if (props.editMode) {
      rxShowExitModal.next(false);
    }
  };

  const handleSwitchToLogin = () => {
    setSignUpModalIsOpen(false);
    setLoginPopUpOpen(true);
  };

  const handleSwitchToSignUo = () => {
    setLoginPopUpOpen(false);
    setSignUpModalIsOpen(true);
  };

  const handleSaveWebSite = () => {
    setSavePopUpOpen(false);
    setSignUpModalIsOpen(true);
  };

  const handleRedirectToHomePage = () => {
    const homeLink = `${CONSULT_URL}/console/login`;
    window.open(homeLink, '_self');
  };

  const handleEditButtonPressed = () => {
    if (hasUserLoggedIn) {
      setParam('generated', undefined);
    } else {
      setSignUpModalIsOpen(true);
    }
  };

  return (
    <div style={{ height: '100%' }}>

       {loading !== '' && (
        <div className={s.loading}>
          <div className={s.spinner}>
            <Spinner size={110} />
          </div>
          <div className={s.message}>
            {loading}
          </div>
        </div>
      )}


      {error && loading === '' ? (
        <div className={s.loading}>
          <h1 className="header error">LOADING DATA ERROR</h1>
        </div>
      ) : ( 
        <>
          {props.editMode && !generated ? (
            //EDITOR Mode
            <AppStyle loading={loading} isAdmin={isAdmin()}>
              <ToolbarStyle>
                <ToolbarPanel
                  editorState={editor.state}
                  changeEditor={(editorState) =>
                    handleChangeEditor(editorState)
                  }
                  onPublishClicked={() => setSignUpModalIsOpen(true)}
                  onHomeClicked={() => setSavePopUpOpen(true)}
                />
              </ToolbarStyle>
              <div className="main-content">
                <SidebarStyle>
                  <SideMenu />
                </SidebarStyle>
                <EditorStateContext.Provider
                  value={{
                    editor: editor,
                    setEditorState: setEditorState.bind(this),
                  }}
                >
                  <CanvasStyle id="view-canvas">
                    <View
                      id="editorView"
                      key="editor-view"
                      liveMode={false}
                      page={props.page}
                      username={props.username}
                      productId={props.productId}
                      productMode={props.productMode}
                      modalView={false}
                    />
                    <ModalExit
                      liveMode={!props.editMode}
                      productId={props.productId}
                      page={props.page}
                      onClose={handleCloseExitModal}
                    />
                  </CanvasStyle>

                  {isAdmin() ? <SectionEditor /> : null}

                  {/* <Alerts/> */}
                </EditorStateContext.Provider>
                <SaveWebSite
                  onClose={() => setSavePopUpOpen(false)}
                  onExit={() => handleRedirectToHomePage()}
                  onSave={() => handleSaveWebSite()}
                  open={savePopUpOpen}
                />
                <Login
                  onSubmit={() => {}}
                  onSwitchToSignUp={() => handleSwitchToSignUo()}
                  open={loginPopUpOpen}
                />
                <SignUpPopup
                  open={signUpModalIsOpen}
                  onSubmit={(values) => {}}
                  onSwitchToLogIn={() => handleSwitchToLogin()}
                />
                <RecommendUseDesktopPopup
                  open={recommendUseDesktopModalIsOpen}
                  onClose={() => setRecommendUseDesktopModalIsOpen(false)}
                />
              </div>
            </AppStyle>
          ) : (
            //LIVE Mode
            <>
              {generated && (
                <OpenEditorPanel
                  onSave={() => handleSaveEditorPanel()}
                  onEdit={() => handleEditButtonPressed()}
                />
              )}
              <>
                <SignUpPopup
                  open={signUpModalIsOpen}
                  onSubmit={(values) => {}}
                  onClose={() => {
                    setSignUpModalIsOpen(false);
                    setModalHasBeenClosed(true);
                  }}
                  onSwitchToLogIn={() => handleSwitchToLogin()}
                  isModal={true}
                  versionStripePage={stripePlanView}
                />
                <Login
                  onSubmit={() => {}}
                  onSwitchToSignUp={() => handleSwitchToSignUo()}
                  open={loginPopUpOpen}
                  onClose={() => {
                    setLoginPopUpOpen(false);
                    setModalHasBeenClosed(true);
                  }}
                />
              </>

              <View
                id="liveView"
                liveMode={true}
                username={props.username}
                productId={props.productId}
                page={props.page}
                productMode={props.productMode}
              />
              <ModalExit
                liveMode={true}
                productId={props.productId}
                page={props.page}
                onClose={handleCloseExitModal}
              />
            </>
          )}
        </>
      )} 
    </div>
  );
};

export default PageApp;
